import React from 'react';
import tw from 'twin.macro';
import useIsMobile from '@teetsh/app/src/components/ResponsiveSwitcher/useIsMobile';
import { useTranslation } from 'react-i18next';
import { TitleWithEditButton } from '@teetsh/app/src/components/TitleWithEditButton';
import { useOpenUpdateEDTInfoModal } from '@teetsh/app/src/containers/EmploiDuTemps/UpdateEDTInfoModal/useOpenUpdateEDTInfoModal';

interface EdtToolbarCenterProps {
  edtId: string;
  name: string;
  subtitle: string;
  isReadOnly?: boolean;
}

export function EdtToolbarCenter({
  edtId,
  name,
  subtitle,
  isReadOnly,
}: EdtToolbarCenterProps) {
  const { t } = useTranslation(['emploiDuTemps']);
  const isMobile = useIsMobile();
  const openUpdateModal = useOpenUpdateEDTInfoModal();

  return (
    <div tw="flex flex-col items-center gap-1 min-w-0 max-w-full 2xl:mb-2">
      <TitleWithEditButton
        title={name || t('emploiDuTemps:topbar.titlePlaceholder')}
        onEdit={() => openUpdateModal({ id: edtId, name, subtitle })}
        isReadOnly={isReadOnly}
        css={[isMobile ? tw`text-2xl font-black` : tw`display`]}
      />
      {subtitle && <p tw="text-center text-neutral-quiet">{subtitle}</p>}
    </div>
  );
}
